/*
export const someGetter = (state) => {
}
*/
import _ from 'lodash';
import utils from '../others/utils.js';

const ACTIVE = 1;
// const PENDING = 2;
const COMPLETED = 3;
// const CANCELED = 4;
export default {
  userScreenName(state) {
    const userNameF = (md5email) => {
      console.log('*********state.settings.users must be users list!!!!!!!!!', state.settings.users);
      const user = state.settings.users.find(item => (item.roles[0] === md5email));
      return user ? user.screenname : '????';
    };
    return userNameF;
  },
  isAdmin(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.includes(`${state.user.db}_admin`);
  },
  isDispatcher(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.includes(`${state.user.db}_dispatcher`);
  },
  isEngineer(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.includes(`${state.user.db}_engineer`);
  },
  isReader(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.includes(`${state.user.db}_reader`);
  },
  wikiEnabled(state) {
    if (!state.user || state.syncing === 'off') {
      return false;
    }
    return state.user.roles.some(role => role.startsWith('wiki_'));
  },
  engineers(state) {
    console.log('*********state.settings.users must be users list!!!!!!!!!', state.settings.users);
    if (!state.settings.users) {
      return [];
    }
    return state.settings.users
      .filter(item => item.roles.includes(`${state.user.db}_engineer`))
      .map(item => ({ label: item.screenname, value: item.roles[0] }));
  },
  subTree(state, getters) {
    const subTreeF = (base) => {
      if (_.isEmpty(state.units) || _.isEmpty(state.parents) || !base) {
        console.log('ERROR ************************************');
        return [];
      }
      return (utils.o2a(state.parents[base]))
        .map((id) => {
          const child = id[0] === 'c' ? utils.formatCase(state.cases[id], state) : getters.formatUnit(id);
          if (child.type === 'div') {
            child.children = getters.subTree(child._id);
          }
          return child;
        })
        .sort((a, b) => {
          if (a.type === b.type) {
            if (a.type === 'cas') {
              if (a.status === b.status) {
                if (a.status === ACTIVE) {
                  return a.workDate - b.workDate;
                } else if (a.status === COMPLETED) {
                  return b.workDate - a.workDate;
                }
                return a.requestId - b.requestId;
              }
              return a.status - b.status;
            }
            return a.label.localeCompare(b.label);
          }
          return a.type.localeCompare(b.type);
        });
    };
    return subTreeF;
  },
  /**
   * formatUnit
   * @param state
   * @returns {Function}
   */
  formatUnit(state) {
    const formatUnitF = (id) => {
      if (!id || (id === 'root')) return null;
      if (id[0] === 'c' && state.cases[id]) {
        /** cases ******************************************************************************
         * status
         * canceled -- canceled = true
         * active -- has not completed work with date
         *  pending -- no works or has work without date
         *  completed -- all work completed
         *
         *  activelate, activehot,activecold
         *
         */
        console.log('ERRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRROR***************************************************');
      }
      // others *************************************************************************
      if (id[0] !== 'c' && state.units[id]) {
        const unit = Object.assign({}, state.units[id]);
        unit.type = id.substr(0, 3);
        unit.created = utils.id2date(id);
        if (unit.medias && unit.medias[0]) {
          const medias = unit.medias.map(media => Object.assign({}, media, {
            local: !!state.offMedias[media.id],
            dND: !!(state.offMedias[media.id] && state.offMedias[media.id].dnd),
          }));
          unit.medias = medias;
        }
        if (unit.type === 'hos') {
          unit.isDef = (unit.city === state.settings.defaultCity);
          unit.label = unit.isDef ? unit.abbr : `${unit.city} ${unit.abbr}`;
          unit.link = `/list/${id}`;
        }
        if (unit.type === 'ins') {
          unit.label = unit.name + (unit.serial ? ` (${unit.serial})` : '');
          unit.icon = 'icon-instrument';
          unit.link = `/list/${id}`;
          if (unit.dateInstall) {
            unit.dateInstall = new Date(unit.dateInstall);
          }
        }
        if (unit.type === 'per') {
          unit.label = unit.name + (unit.appointment ? ` (${unit.appointment})` : '');
          unit.link = `/list/${id}`;
          unit.icon = 'fa-user';
        }
        if (unit.type === 'div') {
          unit.label = unit.abbr;
          unit.link = `/list/${id}`;
          unit.icon = 'fa-sitemap';
        }
        return unit;
      }
      return { label: '**Объект не найден!**', link: '#' };
    };
    return formatUnitF;
  },
  normalizedHospitals(state) {
    if (_.isEmpty(state.units) || _.isEmpty(state.parents)) {
      return [];
    }
    return (utils.o2a(state.parents.root))
      .map((id) => {
        const hosp = Object.assign({}, state.units[id]);
        hosp.isDef = (hosp.city === state.settings.defaultCity);
        hosp.label = hosp.isDef ? hosp.abbr : `${hosp.city} ${hosp.abbr}`;
        hosp.link = `/list/${id}`;
        hosp.expanded = false;
        hosp.icon = 'fa-building';
        hosp.children =
            utils.o2a(state.parents[id])
              .filter(i => (i.startsWith('div:')))
              .map((i) => {
                const div = Object.assign({}, state.units[i]);
                div.label = div.abbr;
                div.link = `/list/${i}`;
                div.expanded = false;
                div.children = [];
                div.icon = 'fa-sitemap';
                return div;
              })
              .sort((a, b) => a.abbr.localeCompare(b.abbr));
        return hosp;
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/getters.js